import * as AppConstants from 'app/AppConstants';
import {
  getUserById,
  isUserLoading,
  selectUserDetailsById,
  isUserDetailsLoading,
  selectAllUsersOffset,
} from './userSelectors';
import {
  fetchUsers,
  getUserDetailsByIds,
  fetchCardStatistics,
} from './userService';
import {buffer} from 'utilities/actionCreatorUtilities';
import flatten from 'lodash/flatten';
import filter from 'lodash/filter';

const LIMIT = 50;

export const load = buffer((args, dispatch, getState) => {
  const state = getState();
  const ids = filter(flatten(args), id => {
    return !getUserById(state, id) && !isUserLoading(state, id);
  });
  if (ids.length === 0) return null;

  dispatch({
    type: AppConstants.USER__LOAD_USERS_STARTED,
    payload: {
      ids,
    },
  });

  fetchUsers({id: ids.join(',')}).then(
    response => {
      dispatch({
        type: AppConstants.USER__LOAD_USERS_FINISHED,
        payload: response,
      });
    },
    () => {
      dispatch({
        type: AppConstants.USER__LOAD_USERS_FAILED,
        payload: {
          ids,
        },
      });
    }
  );
});

export const loadDetails = buffer((args, dispatch, getState) => {
  const state = getState();
  const ids = filter(flatten(args), id => {
    return (
      !selectUserDetailsById(state, id) && !isUserDetailsLoading(state, id)
    );
  });
  if (ids.length === 0) return null;

  dispatch({
    type: AppConstants.USER__LOAD_USERS_DETAILS_STARTED,
    payload: {
      ids,
    },
  });

  getUserDetailsByIds(ids).then(
    response => {
      dispatch({
        type: AppConstants.USER__LOAD_USERS_DETAILS_FINISHED,
        payload: response.userDetails,
      });
    },
    () => {
      dispatch({
        type: AppConstants.USER__LOAD_USERS_DETAILS_FAILED,
        payload: {
          ids,
        },
      });
    }
  );
});

export const loadCardStatistics = userId => dispatch =>
  fetchCardStatistics(userId).then(response => {
    dispatch({
      type: AppConstants.USER__CARD_STATISTICS_LOADED,
      payload: {
        userId,
        statistics: response,
      },
    });
  });

export const loadAllUsers = () => (dispatch, getState) => {
  const offset = selectAllUsersOffset(getState());

  dispatch({
    type: AppConstants.USER__LOAD_ALL_USERS_STARTED,
    payload: {
      offset,
    },
  });

  return fetchUsers({limit: LIMIT, offset}).then(response => {
    dispatch({
      type: AppConstants.USER__LOAD_ALL_USERS_FINISHED,
      payload: {
        offset,
        users: response,
      },
    });
  });
};
